export default "__VITE_ASSET__BAAI$8cL__"